import React, { useState } from 'react';
import './invoice-data.sass';
import { Button, ButtonSize, ButtonType } from '../../../../../components/interface/button/button';
import { EditInvoiceModal } from '../edit-invoice-modal/edit-invoice.modal';

export const InvoiceData = ({name, nip, street, city, postalCode}) => {

  const [isEditInvoiceModalVisible, setIsEditInvoiceModalVisible] = useState(false);

  return (
    <div className='vv-invoice-data'>
      <EditInvoiceModal name={name} nip={nip} street={street} city={city} postalCode={postalCode} isVisible={isEditInvoiceModalVisible} setIsVisible={setIsEditInvoiceModalVisible}/>
      <span className='vv-invoice-data__label'>{name}</span>
      <span className='vv-invoice-data__label'>{street}</span>
      <span className='vv-invoice-data__label'>{`${postalCode} ${city}`}</span>
      <span className='vv-invoice-data__label'>NIP: {nip}</span>
      <Button text='edytuj dane' buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.VENDOR} onClick={() => setIsEditInvoiceModalVisible(true)}/>
    </div>
  );
};
